export default __webpack_public_path__ + "static/media/Will-Pearson.60a3f015.jpg";